import { Reveal } from "@/components/bits";
import PreorderCta from "@/components/store/PreorderCta";

const STEPS = [
  {
    title: "Pick your POSSOS",
    body: "Head to the Product Page and choose your colour and size.",
  },
  {
    title: "Preorder your pair",
    body: "Reserve your pair from the upcoming production run.",
  },
  {
    title: "We make + ship them",
    body: "Updates through production, then POSSOs at your door.",
  },
];

// How preordering works — a bright yellow band, three scannable steps, done.
export default function EasySteps() {
  return (
    <section data-testid="easy-steps" className="bg-ivory">
      <div className="px-4 py-12 sm:py-16 max-w-2xl mx-auto w-full">
        <Reveal>
          <p className="font-body font-bold text-[11px] tracking-[0.22em] uppercase text-ink/50">
            HOW IT WORKS
          </p>
          <h2 className="mt-3 font-display uppercase leading-[0.95] text-[10.5vw] sm:text-5xl">
            Getting your POSSOS is <span className="text-[#FF6BAA]">easy.</span>
          </h2>
          <div className="mt-8 grid gap-3">
            {STEPS.map((s, i) => (
              <div
                key={s.title}
                data-testid={`step-${i + 1}`}
                className="flex gap-4 items-center rounded-2xl border-2 border-ink bg-white p-4 shadow-[3px_3px_0px_#111111]"
              >
                <span className="shrink-0 w-11 h-11 rounded-full border-2 border-ink bg-[#FFD84D] inline-flex items-center justify-center font-display text-sm">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-display uppercase tracking-wide text-lg leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-0.5 text-sm text-ink/70">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
          <PreorderCta
            testId="steps-cta"
            origin="landing_steps"
            className="mt-8 w-full sm:max-w-sm"
          />
        </Reveal>
      </div>
    </section>
  );
}
